import template from './sw-cms-block-text.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
